import React from 'react';
import './About.css';

const About = () => {
    return (
        <section id="about" className="about">
            <div className="container">
                <div className="section-title">O nas</div>
                <div className="section-subtitle">Poznaj naszą historię i wartości</div>
                <div className="about-grid">
                    <div className="about-content">
                        <p>Strefa Napędu to profesjonalny warsztat samochodowy z siedzibą w Rzeszowie przy ul.Żółkiewskiego 4. Specjalizujemy się w naprawie pojazdów hybrydowych, elektrycznych oraz spalinowych.</p>
                        <p>Nasz zespół to doświadczeni mechanicy i elektrycy samochodowi, którzy stale podnoszą swoje kwalifikacje. Korzystamy z najnowocześniejszego sprzętu diagnostycznego.</p>
                        <div className="about-features">
                            <div><i className="fas fa-check-circle"></i> Kompleksowa naprawa silników i skrzyń biegów</div>
                            <div><i className="fas fa-check-circle"></i> Serwis hybrydowych baterii</div>
                            <div><i className="fas fa-check-circle"></i> Autoelektryka </div>
                            <div><i className="fas fa-check-circle"></i> Gwarancja na wszystkie usługi</div>
                        </div>
                    </div>
                    <div className="about-stats">
                        <div className="stat-item">
                            <div className="stat-number">5+</div>
                            <div className="stat-label">Lat doświadczenia</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">200+</div>
                            <div className="stat-label">Zadowolonych klientów</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">24/7</div>
                            <div className="stat-label">Wsparcie telefoniczne</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;